import { useState } from 'react';
import Accordion from './Accordion';
import ImageComparison from './ImageComparison';
import BulletList from '../shared/BulletList';
import SectionHeading from '../shared/SectionHeading';
import { TEXT_STYLES, BORDER_STYLES } from '../../constants/styles';

function ProjectProblem({ id, title, whatWasHappening, keyFindings = [], whyItMattered, designFocus = [], oldStructure, newStructure, headerImage }) {
  const [showNewStructure, setShowNewStructure] = useState(true);

  if (!title) return null;

  return (
    <div id={id} className="max-w-3xl mx-auto space-y-6 mb-16 scroll-mt-32">
      <div className="prose prose-lg">
        {title && <SectionHeading>{title}</SectionHeading>}
        
        {whatWasHappening && (
          <div className="mb-6">
            <p className={TEXT_STYLES.body}>{whatWasHappening}</p>
          </div>
        )}

        {keyFindings && keyFindings.length > 0 && (
          <Accordion title="Key findings">
            <BulletList items={keyFindings} />
          </Accordion>
        )}

        {designFocus && designFocus.length > 0 && (
          <Accordion title="Design focus">
            <BulletList items={designFocus} />
          </Accordion>
        )}

        {(oldStructure || newStructure) && (
          <ImageComparison
            oldImage={oldStructure}
            newImage={newStructure}
            oldAlt="Old Structure"
            newAlt="New Structure"
            showNew={showNewStructure}
            onToggle={setShowNewStructure}
            leftLabel="Old Structure"
            rightLabel="New Structure"
            ariaLabel="Toggle structure view"
          />
        )}

        {headerImage && (
          <div className="mt-8">
            <img
              src={headerImage}
              alt="RIBO Header"
              className={`w-full h-auto ${BORDER_STYLES.rounded} ${BORDER_STYLES.default}`}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProjectProblem;

